module.exports = __webpack_public_path__ + "media/images/vod_icons/cyclebar-411b4563115592978769c4b92f0ebf11.svg";